// Api
import * as Api from "office/reports/stats/api";
// Helpers
import { notifier } from "common/notifier";
import DateHelper from "common/utils/DateHelper";
import moment from "moment";
//-------------------------------------------------------------------------------------------------------------------------------
export const FETCHING = "REPORT_OFFICE_FETCHING_STATS";
export const LOAD = "REPORT_OFFICE_STATS";
export const ERROR = "REPORT_OFFICE_ERROR_STATS";
export function fetchingData(officeId, fromDate, toDate) {
    return {
        type: FETCHING,
        officeId: officeId,
        fromDate: fromDate,
        toDate: toDate
    };
}
export function recievedData(report) {
    return {
        type: LOAD,
        report: report
    };
}
export function errorData(officeId, fromDate, toDate) {
    return {
        type: ERROR,
        officeId: officeId,
        fromDate: fromDate,
        toDate: toDate
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
export const getForced = (officeId) => {
    return (dispatch) => {
        let defaultRange = DateHelper.getLast90Days();
        //        let defaultRange = DateHelper.getLast7Days();
        getOfficeStats(dispatch, officeId, defaultRange[0], defaultRange[1]);
    };
};
export const getIfNeeded = (officeId, currentDates, pickedDates) => {
    return (dispatch) => {
        if (!DateHelper.compareDates(moment(currentDates[0]), pickedDates[0]) ||
            !DateHelper.compareDates(moment(currentDates[1]), pickedDates[1])) {
            getOfficeStats(dispatch, officeId, pickedDates[0], pickedDates[1]);
        }
    };
};
export const reset = (officeId, fromDate, toDate) => {
    return (dispatch) => {
        let defaultRange = DateHelper.getLastMonth();
        if (!DateHelper.compareDates(moment(fromDate), defaultRange[0]) ||
            !DateHelper.compareDates(moment(toDate), defaultRange[1])) {
            getOfficeStats(dispatch, officeId, defaultRange[0], defaultRange[1]);
        }
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
const getOfficeStats = (dispatch, officeId, fromDate, toDate) => {
    // Dispatch that we are fetching the report
    dispatch(fetchingData(officeId, fromDate, toDate));
    // Fetch
    Api.async_officeStatsRequest(dispatch, officeId, fromDate, toDate)
        .then((report) => {
        dispatch(recievedData(report));
    }, (message) => {
        console.log("OfficeReports => Stats => Error: ", message);
        notifier.notifyError("Error Generating Report", message);
        dispatch(errorData(officeId, fromDate, toDate));
    });
};
